import styles from '../CandidateDetailsContainer.module.scss'

import { Flex } from '@percent/lemonade'
import { CandidateNominationsCardProps } from './CandidateNominationsCard.types'
import { CandidateNomination } from './candidateNomination/CandidateNomination'

export function CandidateNominationsCard({ nominations }: Readonly<CandidateNominationsCardProps>) {
  return (
    <Flex direction="column" data-testid="candidate-nomination-card" className={styles.cardCtn} gap={16}>
      {nominations.map((nomination, index) => (
        <CandidateNomination key={nomination.id} nomination={nomination} index={index + 1} />
      ))}
    </Flex>
  )
}
